import {connect} from 'react-redux';
import Step8 from './Step8';
import {submitStep} from "../../actions/submitStep";
import {uploadFile} from "../../actions/uploadFile";
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";

const mapStateToProps = ({
                           regType: {regType},
                           locales: {current: language},
                           stepPayload: {payload},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  payload,
  language,
  prevCompletedStepSign,
});

export default connect(
  mapStateToProps,
  {submitStep, uploadFile, prevCompletedStepSignFalse}
)(Step8);
